var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"login-wrapper"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('div',{staticClass:"logo-wrapper"},[_c('img',{attrs:{"src":"funxtion.png"}})])])],1),_c('b-row',[_c('b-col',[_c('login-form',{on:{"submit":_vm.onSubmit}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }